// THIS FILE IS AUTO-GENERATED BY FIGMAGIC. DO NOT MAKE EDITS IN THIS FILE! CHANGES WILL GET OVER-WRITTEN BY ANY FURTHER PROCESSING.
const opacities = {
    opaque: 1,
    disabled: 0.65,
    semiOpaque: 0.5,
    transparent: 0,
};
module.exports = opacities;
//# sourceMappingURL=opacities.js.map